export default __webpack_public_path__ + "static/P_SearchThumb_IN-6012HD-430a07ef24439206036cf57ac2e92555.webp";